import React, { useState, Children } from 'react';
import { ExternalLinkIcon, GithubIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Projects() {
  const [activeFilter, setActiveFilter] = useState('all');
  const projects = [{
    id: 1,
    title: 'Network Security Implementation',
    category: 'security',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
    description: 'A comprehensive security solution for enterprise networks including firewall configuration and threat monitoring.',
    tags: ['Network Security', 'Firewall', 'Monitoring'],
    demoLink: '#',
    codeLink: '#'
  }, {
    id: 2,
    title: 'System Monitoring Dashboard',
    category: 'app',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
    description: 'A real-time monitoring dashboard for system performance and security alerts.',
    tags: ['Monitoring', 'Dashboard', 'Security'],
    demoLink: '#',
    codeLink: '#'
  }, {
    id: 3,
    title: 'Cybersecurity Training Portal',
    category: 'web',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
    description: 'An educational platform for cybersecurity awareness and training.',
    tags: ['Education', 'Cybersecurity', 'Web'],
    demoLink: '#',
    codeLink: '#'
  }, {
    id: 4,
    title: 'Network Diagnostics Tool',
    category: 'app',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
    description: 'A tool for diagnosing and troubleshooting network connectivity issues.',
    tags: ['Networking', 'Diagnostics', 'Tool'],
    demoLink: '#',
    codeLink: '#'
  }, {
    id: 5,
    title: 'IT Support Knowledge Base',
    category: 'web',
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
    description: 'A comprehensive knowledge base for common IT support issues and solutions.',
    tags: ['IT Support', 'Knowledge Base', 'Documentation'],
    demoLink: '#',
    codeLink: '#'
  }, {
    id: 6,
    title: 'System Recovery Toolkit',
    category: 'app',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80',
    description: 'A collection of tools for system recovery and data rescue operations.',
    tags: ['Recovery', 'System', 'Tools'],
    demoLink: '#',
    codeLink: '#'
  }];
  const filteredProjects = activeFilter === 'all' ? projects : projects.filter(project => project.category === activeFilter);
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="projects" className="py-20 bg-gray-50 px-4" data-id="element-178">
      <div className="container mx-auto max-w-5xl" data-id="element-179">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-180">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-181">
            My Projects
          </h2>
          <div className="w-20 h-1 bg-purple-600 mx-auto mb-8" data-id="element-182"></div>
          <div className="flex flex-wrap justify-center mb-8" data-id="element-183">
            <motion.button className={`mx-2 px-4 py-2 rounded-md ${activeFilter === 'all' ? 'bg-purple-600 text-white' : 'bg-white text-gray-700 border border-gray-300'}`} onClick={() => setActiveFilter('all')} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-184">
              All
            </motion.button>
            <motion.button className={`mx-2 px-4 py-2 rounded-md ${activeFilter === 'web' ? 'bg-purple-600 text-white' : 'bg-white text-gray-700 border border-gray-300'}`} onClick={() => setActiveFilter('web')} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-185">
              Web
            </motion.button>
            <motion.button className={`mx-2 px-4 py-2 rounded-md ${activeFilter === 'app' ? 'bg-purple-600 text-white' : 'bg-white text-gray-700 border border-gray-300'}`} onClick={() => setActiveFilter('app')} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-186">
              App
            </motion.button>
            <motion.button className={`mx-2 px-4 py-2 rounded-md ${activeFilter === 'security' ? 'bg-purple-600 text-white' : 'bg-white text-gray-700 border border-gray-300'}`} onClick={() => setActiveFilter('security')} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-187">
              Security
            </motion.button>
          </div>
        </motion.div>
        <motion.div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} data-id="element-188">
          {filteredProjects.map(project => <motion.div key={project.id} className="bg-white rounded-lg overflow-hidden shadow-md" variants={cardVariants} whileHover={{
          y: -10,
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
        }} data-id="element-189">
              <div className="h-48 overflow-hidden" data-id="element-190">
                <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-110" data-id="element-191" />
              </div>
              <div className="p-6" data-id="element-192">
                <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-193">
                  {project.title}
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-194">{project.description}</p>
                <div className="flex flex-wrap mb-4" data-id="element-195">
                  {project.tags.map((tag, index) => <span key={index} className="bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded mr-2 mb-2" data-id="element-196">
                      {tag}
                    </span>)}
                </div>
                <div className="flex justify-between" data-id="element-197">
                  <motion.a href={project.demoLink} className="flex items-center text-purple-600 hover:text-purple-800" aria-label={`View live demo of ${project.title}`} whileHover={{
                scale: 1.05
              }} data-id="element-198">
                    <ExternalLinkIcon size={18} className="mr-1" data-id="element-199" /> Demo
                  </motion.a>
                  <motion.a href={project.codeLink} className="flex items-center text-purple-600 hover:text-purple-800" aria-label={`View source code of ${project.title}`} whileHover={{
                scale: 1.05
              }} data-id="element-200">
                    <GithubIcon size={18} className="mr-1" data-id="element-201" /> Code
                  </motion.a>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}